export default "__VITE_ASSET__BcQcgRsA__"